export * from './sbr-slider';